import { type RefCallback, useEffect, useState } from 'react';

/** Keep the pinned chrome inside the keyboard-reduced viewport, including iOS panning. */
export function useWizardViewport(open: boolean): RefCallback<HTMLDivElement> {
  const [element, setElement] = useState<HTMLDivElement | null>(null);
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!open || element === null || viewport === null || viewport === undefined) {
      return;
    }
    const update = (): void => {
      element.style.setProperty('--wizard-viewport-height', `${viewport.height}px`);
      element.style.setProperty('--wizard-viewport-top', `${viewport.offsetTop}px`);
    };
    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      element.style.removeProperty('--wizard-viewport-height');
      element.style.removeProperty('--wizard-viewport-top');
    };
  }, [element, open]);
  return setElement;
}
